import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText, {
  Opts as ButtonScaleViewWithTextOpts,
} from 'src/lib/ui/components/ButtonScaleViewWithText';
import bitmapFonts from 'src/lib/bitmapFonts';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import ScrollBasic from '../components/shared/ScrollBasic';
import { Minigame, MinigameType } from 'src/replicant/minigame';
import { MinigameTile } from '../components/MinigameTile';
import { LangBitmapOpts } from '../../lib/ui/components/LangBitmapFontTextView';

namespace ui {
  export const popup = {
    zIndex: 10000,
    width: uiConfig.popups.buruburu.width,
    height: 915,
    darkerBg: false,
  };

  export const message: LangBitmapOpts = {
    size: 30,
    height: 64,
    x: 52,
    y: 89,
    zIndex: 1,
  };
  message.width = uiConfig.popups.buruburu.width - 2 * message.x;

  export const underline = {
    width: message.width,
    y: message.height,
    height: 4,
    backgroundColor: '#FDC381',
  };

  export const scrollContainer = {
    showBg: true,
    rect: {
      x: 30,
      y: 170,
      width: popup.width - 60,
      height: 600,
    },
  };

  export const cancelButton: Omit<ButtonScaleViewWithTextOpts, 'tracking'> = {
    ...uiConfig.buttons.cancel,
    labelOffsetY: -1,
    fontSize: 46,
    font: bitmapFonts('Body'),
    x: popup.width / 2,
    width: 259,
    height: 100,
    centerOnOrigin: true,
  };
  cancelButton.y = popup.height - 25 - cancelButton.height / 2;
}

type CloseHandler = (result?: MinigameType) => void;

export default class PopupSelectMinigame extends PopupBasic {
  private buttonCancel: ButtonScaleViewWithText;
  private close: CloseHandler;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      ...ui.popup,
      superview: opts.superview,
      close: () => opts.close(),
      tracking: { feature: 'minigame', $subFeature: 'popup-select' },
    });

    this.close = opts.close;
    this.buttonClose.removeFromSuperview();

    this.message.updateOpts(ui.message);

    this.message.addSubview(new View(ui.underline));

    const minigameList = new ScrollBasic<MinigameType>({
      ...ui.scrollContainer,
      superview: this.box,
      createItem: this.createItem.bind(this),
    });
    minigameList.setItems([...Minigame.ruleset.minigameTypes]);

    this.buttonCancel = this.box.addSubview(
      new ButtonScaleViewWithText({
        ...ui.cancelButton,
        localeText: () => i18n('basic.close'),
        onClick: async () => {
          sounds.sfx.play('cancel');
          return opts.close();
        },
        tracking: { feature: 'care', $subFeature: 'popup-invitefriends-close' },
      }),
    );
  }

  init(_: any) {
    super.init({
      title: i18n('minigame.selectionPopup.title'),
      message: i18n('minigame.selectionPopup.message'),
    });
  }

  private createItem(superview: View, _: number, type: MinigameType) {
    return superview.addSubview(
      new MinigameTile({
        type,
        onClick: async () => {
          sounds.sfx.play('ok');
          this.close(type);
        },
      }).view,
    );
  }
}
